$(document).ready(function () {
  $("#formtriupdt").on("submit", function (e) {
    e.preventDefault();
    $('#SisSubmitModal').modal('show');
    this.submit();
  });
});